module.exports = __webpack_public_path__ + "img/2021-02.0f598543.jpg";